import React from 'react';
import { FiCode, FiSmartphone } from "react-icons/fi";
import { FaPaintBrush } from "react-icons/fa";

const iconMap = {
  "brush-alt": FaPaintBrush,
  "code": FiCode,
  "mobile": FiSmartphone
};

function Service(props){
  const IconComponent = iconMap[props.content.icon];

  return (
    <div className="mi-service">
      <span className="mi-service-icon">
        <IconComponent />
      </span>
      <h5>{props.content.title}</h5>
      <p>{props.content.details}</p>
    </div>
  )
}

export default Service;
